import axios from '@/store/interceptor';

import apiUrl from '@/config/api.config';

/**
 * Uploads a photo prepared by helper/image.js prepareImage(). The file stays "pending" on the server
 * until a feature links it by id (label_file_id, place_file_id, file_ids).
 * @param {{blob: Blob, thumb: Blob, width?: number, height?: number}} photo
 * @param {'label'|'place'|'comment'} purpose
 * @returns {Promise<{id: number, width: number, height: number, size: number}>}
 */
export async function uploadPhoto(photo, purpose, { onProgress, signal } = {}) {
    const form = new FormData();
    form.append('purpose', purpose);
    if (photo.width) form.append('width', String(photo.width));
    if (photo.height) form.append('height', String(photo.height));
    form.append('file', photo.blob, 'fotografie.jpg');
    form.append('thumb', photo.thumb, 'miniatura.jpg');
    const response = await axios.post(`${apiUrl}/files`, form, {
        signal,
        onUploadProgress: event => {
            if (onProgress && event.total) onProgress(Math.min(100, Math.round((event.loaded * 100) / event.total)));
        },
    });
    return response.data;
}

/** The photo (or its thumbnail) as a Blob, fetched with the JWT (an <img src> cannot send it) */
export async function fetchPhotoBlob(id, variant = 'thumb', { signal } = {}) {
    const url = variant === 'thumb' ? `${apiUrl}/files/${id}/thumb` : `${apiUrl}/files/${id}`;
    const response = await axios.get(url, { responseType: 'blob', signal });
    return response.data;
}

/** Romanian text for a failed upload / download */
export function photoErrorMessage(error, fallback = 'Fotografia nu a putut fi încărcată. Încercați din nou.') {
    if (!error) return fallback;
    if (error.name === 'ImageError') return error.message;
    const response = error.response;
    if (!response) return error.code === 'ERR_NETWORK' ? 'Nu există conexiune cu serverul. Verificați internetul și încercați din nou.' : fallback;
    const data = response.data;
    if (data && typeof data === 'object' && !(data instanceof Blob) && data.message) {
        return Array.isArray(data.message) ? data.message.join('. ') : data.message;
    }
    if (response.status === 403) return 'Nu aveți acces la această fotografie.';
    if (response.status === 404) return 'Fotografia nu mai există.';
    if (response.status === 413) return 'Fotografia este prea mare.';
    return fallback;
}
